/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */

import {
  Box,
  TableCell,
  TableRow,
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  Button as MuiButton,
  Typography,
  IconButton,
  Divider,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import {
  Close as CloseIcon,
  Warning as WarningIcon,
  Person as PersonIcon,
} from "@mui/icons-material";
import React, { useContext, useState } from "react";
import * as Sentry from "@sentry/react";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import tableStyle from "../../../theme/styles/table";
import { style } from "../../appointment/AppointmentTracking/style";

import Table from "../../../components/common/new/Table/Table";
import { AlertStatus } from "../../../contants";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import { GOHONZON_TRACKING_COL } from "../../../contants/table/gohonzonSearch";
import { getGohonzonType } from "../../../utils";
import Gohonzon from "../../../services/api/gohonzon";

const tabelCellWidth = {
  tiny: { maxWidth: "3.5rem" },
  small: { maxWidth: "6rem" },
  medium: { maxWidth: "10rem" },
};

// Enhanced Dialog Styles
const dialogStyles = {
  paper: {
    borderRadius: "16px",
    boxShadow:
      "0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 11px 15px -7px rgba(0, 0, 0, 0.20)",
    maxWidth: "500px",
    width: "100%",
    margin: "16px",
  },
  header: {
    background: "linear-gradient(135deg, #ff4757 0%, #ff3838 100%)",
    color: "white",
    padding: "24px 24px 20px 24px",
    position: "relative",
    borderRadius: "16px 16px 0 0",
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: "600",
    margin: 0,
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  closeButton: {
    position: "absolute",
    right: "16px",
    top: "16px",
    color: "white",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.2)",
    },
  },
  content: {
    padding: "32px 24px 24px 24px",
    backgroundColor: "#fafafa",
  },
  memberInfo: {
    backgroundColor: "white",
    borderRadius: "12px",
    padding: "20px",
    marginBottom: "24px",
    border: "1px solid #e0e0e0",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
  },
  memberDetail: {
    display: "flex",
    alignItems: "center",
    marginBottom: "8px",
    "&:last-child": {
      marginBottom: 0,
    },
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      backgroundColor: "white",
      "&:hover fieldset": {
        borderColor: "#ff4757",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#ff4757",
      },
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#ff4757",
    },
  },
  actions: {
    padding: "16px 24px 24px 24px",
    backgroundColor: "#fafafa",
    borderRadius: "0 0 16px 16px",
    gap: "12px",
  },
  cancelButton: {
    borderRadius: "10px",
    textTransform: "none",
    fontWeight: "600",
    padding: "12px 24px",
    border: "2px solid #e0e0e0",
    color: "#666",
    "&:hover": {
      backgroundColor: "#f5f5f5",
      borderColor: "#bdbdbd",
    },
  },
  confirmButton: {
    borderRadius: "10px",
    textTransform: "none",
    fontWeight: "600",
    padding: "12px 24px",
    background: "linear-gradient(135deg, #ff4757 0%, #ff3838 100%)",
    boxShadow: "0 4px 15px rgba(255, 71, 87, 0.3)",
    "&:hover": {
      background: "linear-gradient(135deg, #ff3838 0%, #ff2929 100%)",
      boxShadow: "0 6px 20px rgba(255, 71, 87, 0.4)",
    },
    "&:disabled": {
      background: "#ccc",
      color: "#666",
      boxShadow: "none",
    },
  },
  warningIcon: {
    color: "#ff9800",
    marginRight: "8px",
  },
  loadingButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
};

// ---------------- ROWS ----------------
const getRows = ({
  searchData,
  onMemberSelect,
  isHelpDesk,
  isHelpDeskAdmin,
  onCancelClick,
  onCreateBatch,
}) => {
  return searchData?.map((member) => (
    <TableRow key={member?.id} style={tableStyle.tableRow}>
      <TableCell style={{ ...style.Cell, color: "#043D90", fontWeight: "600" }}>
        {member?.memberDetails?.memberId}
      </TableCell>

      <TableCell style={style.Cell}>
        {member?.memberDetails?.fullName || "-"}
        <br />
        {member?.memberDetails?.addressLine1 || "-"}
      </TableCell>

      <TableCell style={style.Cell}>
        {member?.memberDetails?.mobileNumber || "-"}
        <br />
        {member?.memberDetails?.emailId || "-"}
      </TableCell>

      <TableCell style={style.Cell}>
        {member?.memberDetails?.divisionName || "-"}
      </TableCell>

      <TableCell style={{ ...style.Cell, ...tabelCellWidth.medium }}>
        {[
          member?.memberDetails?.areaName,
          member?.memberDetails?.zoneName,
          member?.memberDetails?.regionName,
          member?.memberDetails?.chapterName,
          member?.memberDetails?.districtName,
          member?.memberDetails?.blockName,
        ]
          .filter(Boolean)
          .join("/ ")}
      </TableCell>

      <TableCell style={style.Cell}>
        {getGohonzonType(member?.gohonzonType) || "NA"}
      </TableCell>

      <TableCell style={style.Cell}>
        <Box style={style.status}>{member?.statusValue}</Box>
      </TableCell>

      <TableCell style={{ padding: "16px 12px" }}>
        <Box
          style={{
            display: "flex",
            flexDirection: "row", // 🔹 now row
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            minWidth: "120px",
          }}
        >
          {/* VIEW Icon */}
          <Tooltip title="View">
            <span>
              <IconButton
                onClick={() => {
                  if (member?.formType === "APPLICATION") {
                    onMemberSelect(
                      member?.memberDetails?.memberId,
                      "tracking/preview"
                    );
                  }
                }}
                disabled={member?.formType !== "APPLICATION"}
                style={{
                  backgroundColor:
                    member?.formType === "APPLICATION" ? "#E8F5E8" : "#F5F5F5",
                  border:
                    member?.formType === "APPLICATION"
                      ? "1px solid #52C41A"
                      : "1px solid #D9D9D9",
                  color:
                    member?.formType === "APPLICATION" ? "#52C41A" : "#8C8C8C",
                  boxShadow:
                    member?.formType === "APPLICATION"
                      ? "0 2px 4px rgba(82, 196, 26, 0.15)"
                      : "none",
                  transition: "all 0.2s ease-in-out",
                  width: "38px",
                  height: "38px",
                }}
              >
                <VisibilityOutlinedIcon fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>

          {(isHelpDesk || isHelpDeskAdmin) && (
            <>
              {/* CANCEL Icon */}
              {[
                "BATCH_CREATED",
                "BATCH_HANDOVER",
                "DRAFT",
                "FINAL_INTERVIEWED",
                "INITIATED",
                "INTERVIEWED",
                "VERIFIED",
              ].includes(member?.status) && (
                <Tooltip title="Cancel">
                  <IconButton
                    onClick={() => onCancelClick(member)}
                    style={{
                      backgroundColor: "#FFF2F0",
                      border: "1px solid #FF7875",
                      color: "#CF1322",
                      transition: "all 0.2s ease-in-out",
                      boxShadow: "0 2px 4px rgba(255, 77, 79, 0.15)",
                      width: "38px",
                      height: "38px",
                    }}
                  >
                    <DeleteOutlineIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}

              {/* CREATE BATCH Icon */}
              {["INTERVIEWED"].includes(member?.status) && (
                <Tooltip title="Create Batch">
                  <IconButton
                    onClick={() => onCreateBatch?.(member)}
                    style={{
                      backgroundColor: "#F0F8FF",
                      border: "1px solid #40A9FF",
                      color: "#1677FF",
                      transition: "all 0.2s ease-in-out",
                      boxShadow: "0 2px 4px rgba(22, 119, 255, 0.15)",
                      width: "38px",
                      height: "38px",
                    }}
                  >
                    <AddCircleOutlineIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
            </>
          )}
        </Box>
      </TableCell>
    </TableRow>
  ));
};

// ---------------- MAIN COMPONENT ----------------
function GOhonzonTrackingTable({
  searchData,
  onSelectMemberForTransfer,
  onMemberStatusToggle,
  onMemberSelect,
  hasPermission,
  showStatusColumn,
  onEdit,
  onToggleHDC,
  isChapterSi,
  isHelpDesk,
  isAreaSi,
  isZoneSi,
  isHelpDeskAdmin,
}) {
  const columns = GOHONZON_TRACKING_COL;
  const toast = useContext(ToastAlertContext);

  // Cancel Popup States
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [selectedMember, setSelectedMember] = useState(null);
  const [loading, setLoading] = useState(false);

  // Cancel Flow
  const onCancelClick = (member) => {
    setSelectedMember(member);
    setCancelReason("");
    setCancelDialogOpen(true);
  };

  const onConfirmCancel = async () => {
    try {
      setLoading(true);
      const body = {
        data: { message: cancelReason || "Cancelled by Admin" },
      };

      await Gohonzon.gohonzonReject(
        body,
        selectedMember?.memberDetails?.memberId,
        selectedMember?.id
      );

      toast.show("Member cancelled successfully", AlertStatus.SUCCESS);
      setCancelDialogOpen(false);
    } catch (error) {
      toast.show(error.message || "Cancel failed", AlertStatus.ERROR);
      console.error(error);
      Sentry.captureException(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseDialog = () => {
    if (!loading) {
      setCancelDialogOpen(false);
    }
  };

  // Create Batch
  const onCreateBatch = async (member) => {
    try {
      console.log("Create batch for Application ID →", member?.id);
      toast.show(
        `Batch creating for Application ID: ${member?.id}`,
        AlertStatus.SUCCESS
      );

      const data = { applicationIds: [member?.id] };
      await Gohonzon.createSingleBatch(data);

      toast.show("Batch created successfully", AlertStatus.SUCCESS);
    } catch (error) {
      toast.show(error.message || "Batch creation failed", AlertStatus.ERROR);
      console.error(error);
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <Table
        scrollable
        columns={columns}
        rows={getRows({
          searchData,
          onSelectMemberForTransfer,
          onMemberSelect,
          hasPermission,
          onMemberStatusToggle,
          showStatusColumn,
          isChapterSi,
          isHelpDesk,
          isAreaSi,
          isZoneSi,
          onEdit,
          onToggleHDC,
          isHelpDeskAdmin,
          onCancelClick,
          onCreateBatch,
        })}
        tableHeadCellStyle={{ ...style.tableHeadCells }}
      />

      {/* Enhanced Professional Cancel Reason Dialog */}
      <Dialog
        open={cancelDialogOpen}
        onClose={handleCloseDialog}
        PaperProps={{
          style: dialogStyles.paper,
        }}
        maxWidth={false}
      >
        {/* Custom Header */}
        <Box sx={dialogStyles.header}>
          <Typography variant="h5" sx={dialogStyles.title}>
            <WarningIcon />
            Cancel Member Application
          </Typography>
          <IconButton
            onClick={handleCloseDialog}
            sx={dialogStyles.closeButton}
            disabled={loading}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Content */}
        <DialogContent sx={dialogStyles.content}>
          {/* Member Information Card */}
          {selectedMember && (
            <Box sx={dialogStyles.memberInfo}>
              <Typography
                variant="h6"
                sx={{ marginBottom: "16px", color: "#333", fontWeight: "600" }}
              >
                Member Details
              </Typography>
              <Divider sx={{ marginBottom: "16px" }} />

              <Box sx={dialogStyles.memberDetail}>
                <PersonIcon sx={{ color: "#043D90", marginRight: "12px" }} />
                <Box>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "600", color: "#043D90" }}
                  >
                    {selectedMember?.memberDetails?.fullName || "N/A"}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#666" }}>
                    ID: {selectedMember?.memberDetails?.memberId || "N/A"}
                  </Typography>
                </Box>
              </Box>

              <Box sx={dialogStyles.memberDetail}>
                <Typography variant="body2" sx={{ color: "#666" }}>
                  <strong>Division:</strong>{" "}
                  {selectedMember?.memberDetails?.divisionName || "N/A"}
                </Typography>
              </Box>

              <Box sx={dialogStyles.memberDetail}>
                <Typography variant="body2" sx={{ color: "#666" }}>
                  <strong>Contact:</strong>{" "}
                  {selectedMember?.memberDetails?.mobileNumber || "N/A"}
                </Typography>
              </Box>
            </Box>
          )}

          {/* Warning Message */}
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              marginBottom: "20px",
            }}
          >
            <WarningIcon sx={dialogStyles.warningIcon} />
            <Typography
              variant="body2"
              sx={{ color: "#666", lineHeight: "1.6" }}
            >
              You are about to cancel this member application. This action
              cannot be undone. Please provide a reason for cancellation that
              will be communicated to the member.
            </Typography>
          </Box>

          {/* Reason Input */}
          <TextField
            autoFocus
            label="Cancellation Reason *"
            placeholder="Please enter the reason for cancellation..."
            multiline
            rows={4}
            fullWidth
            variant="outlined"
            value={cancelReason}
            onChange={(e) => setCancelReason(e.target.value)}
            disabled={loading}
            sx={dialogStyles.textField}
            helperText="This message will be sent to the member"
          />
        </DialogContent>

        {/* Actions */}
        <DialogActions sx={dialogStyles.actions}>
          <MuiButton
            onClick={handleCloseDialog}
            disabled={loading}
            sx={dialogStyles.cancelButton}
            size="large"
          >
            Keep Application
          </MuiButton>
          <MuiButton
            onClick={onConfirmCancel}
            color="error"
            variant="contained"
            disabled={loading || !cancelReason.trim()}
            sx={dialogStyles.confirmButton}
            size="large"
          >
            <Box sx={dialogStyles.loadingButton}>
              {loading && <CircularProgress size={16} color="inherit" />}
              {loading ? "Cancelling..." : "Confirm Cancellation"}
            </Box>
          </MuiButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default GOhonzonTrackingTable;
